<template>
  <div ref="point" v-pan="onPan" class="point">
    <div class="point__inputs" v-show="false">
      <input
        class="point__inputs--item"
        type="number"
        :value="x"
        @change="emit(x, y)"
      />
      <input
        class="point__inputs--item"
        type="number"
        :value="y"
        @change="emit(x, y)"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    x: Number,
    y: Number,
  },
  data() {
    return {
      lastPosX: 0,
      lastPosY: 0,
    };
  },
  methods: {
    transform(el, x, y) {
      el.style.position = "absolute";
      el.style.left = x + "px";
      el.style.top = y + "px";
    },
    onPan(ev) {
      let posX = ev.deltaX + this.lastPosX;
      let posY = ev.deltaY + this.lastPosY;

      this.transform(this.$refs.point, posX, posY);

      this.emit(posX, posY);

      if (ev.isFinal) {
        this.lastPosX = posX;
        this.lastPosY = posY;
      }
    },
    emit(x, y) {
      this.$emit("x", x);
      this.$emit("y", y);
    },
  },
  watch: {
    x(v) {
      this.transform(this.$refs.point, v, this.y);
    },
    y(v) {
      this.transform(this.$refs.point, this.x, v);
    },
  },
  mounted() {
    this.lastPosX = this.x;
    this.lastPosY = this.y;
    this.transform(this.$refs.point, this.lastPosX, this.lastPosY);
  },
};
</script>

<style lang="scss" scoped>
.point {
  background: #ec8ab3;
  border: 1px solid #fff;
  width: 10px;
  height: 10px;
  position: absolute;
  border-radius: 100px;
  transform: translate(-50%, -50%);
  cursor: move;

  .point__inputs {
    margin: 10px;
    width: 100px;

    &--item {
      width: 100%;
    }
  }
}
</style>
